import { useEffect, useRef } from 'react'
import { postGrowthEngineAnalytics } from 'src/utils/growthEngineApi'
import {
  GROWTH_ENGINE_FEATURE_OPENED_EVENT,
  GROWTH_ENGINE_FEATURE_OPENED_SOURCE,
  beginFeatureOpenedVisit,
  endFeatureOpenedVisit,
  resolveFeatureOpenedFromPath,
} from 'src/utils/growthEngineFeatureOpened'

/**
 * Post feature_opened once per venue + feature visit when a dedicated
 * feature screen mounts — even if no Growth Engine card is showing.
 *
 * @param {{ venueId?: string|null, pathname?: string|null }} params
 */
export default function useGrowthEngineFeatureOpened({
  venueId,
  pathname,
} = {}) {
  const lastVisitRef = useRef(null)

  useEffect(() => {
    const resolved = resolveFeatureOpenedFromPath(pathname)
    const nextVenueId = venueId ? String(venueId) : ''
    const nextFeatureId = resolved?.featureId || ''
    const nextKey =
      nextVenueId && nextFeatureId ? `${nextVenueId}:${nextFeatureId}` : null

    if (lastVisitRef.current && lastVisitRef.current !== nextKey) {
      const [prevVenueId, prevFeatureId] = lastVisitRef.current.split(':')
      endFeatureOpenedVisit(prevVenueId, prevFeatureId)
    }
    lastVisitRef.current = nextKey

    if (!nextKey || !resolved) return undefined
    if (!beginFeatureOpenedVisit(nextVenueId, nextFeatureId)) return undefined

    postGrowthEngineAnalytics(nextVenueId, {
      eventName: GROWTH_ENGINE_FEATURE_OPENED_EVENT,
      featureId: nextFeatureId,
      platform: 'dashboard',
      metadata: {
        surface: resolved.surface,
        source: GROWTH_ENGINE_FEATURE_OPENED_SOURCE,
      },
    }).catch(err => {
      console.warn('Growth Engine feature_opened failed', err)
    })

    return undefined
  }, [venueId, pathname])
}
